import * as React from 'react';
// @ts-ignore
import * as Dotdotdot from 'react-dotdotdot';
import './index.less';

interface DotDotDotProps {
  clamp: number;
  className?: string;
  children?: React.ReactNode;
}
const DotDotDot: React.FC<DotDotDotProps> = (props) => {

  const { clamp, children = '', className } = props;
  const title = typeof children === 'string' ? children : "";
  //  存在问题, 换行必须为中文字符
  return (
    <div className={`mpc-dot ${className}`} title={title}>
      <Dotdotdot clamp={ clamp || 3}>
        {children}
      </Dotdotdot>
    </div>
  )
}

export default DotDotDot

